import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { LoanService } from "../../shared/loan.service";

@Injectable({
  providedIn: 'root'
})

export class PrintloanapprovalService {

  LoanList: any[] = [];

  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe,) {   }

   GenerateReport(rptSearchData: any) {
    this.loanService.FetchReportsLoanList(rptSearchData)
      .toPromise()
      .then(data => {
        this.ReportGenerateList(data,this.datePipe);
      })
      .catch(err => { console.log(err) });
  }

  //--------------------------------------------------
  // Printing the documents as a lists.  
  ReportGenerateList(LoanList,datePipe: DatePipe) {

    var generateData = function (LoanList) {

      var result = [];
      var itemData = [{}];
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < LoanList.length; i += 1) {
        itemData[i] = {
          Id: LoanList[i].Id.toString(),
          'Customer': LoanList[i].CustomerName.toString(),
          'App. Date':  datePipe.transform(LoanList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'App. No.': LoanList[i].ApplicationNo.toString(),
          'Amount': LoanList[i].LoanAmount.toString(),
          'Centre': LoanList[i].CentreName.toString(),
          'Aadhar No': LoanList[i].AadharNo.toString(),
          'Bank': LoanList[i].BankName.toString(),
          'Bank Account': LoanList[i].BankAcNo.toString(),
          'IFSC': LoanList[i].IFSC.toString(),
        };
      }

      // 'Date': datePipe.transform(LoanList[i].LoanApprovedDate, 'dd-MM-yyyy'),

      for (var i = 0; i < LoanList.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }

      return result;
    };


    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 75,
          align: "left",
          padding: 0,
        });
      }
      console.log("--HeaderResult--");
      console.log(HeaderResult);
      return HeaderResult;
    }

    var headers = createHeaders([
      "Id",
      "Customer",
      "App. Date",
      "App. No.",
      "Amount",
      "Centre",
      "Aadhar No",
      "Bank",
      "Bank Account",
      "IFSC",
    ]);

    // Document of 210mm wide and 297mm high
    // new jsPDF('p', 'mm', [297, 210]);
    // // Document of 297mm wide and 210mm high
    // new jsPDF('l', 'mm', [297, 210]);
    // // Document of 5 inch width and 3 inch high
    // new jsPDF('l', 'in', [3, 5]);

    // let pdf = new jsPDF('l', 'pt', 'legal');    
    // let pdf = new jsPDF('l', 'pt', 'letter');
    let pdf = new jsPDF('p', 'pt', 'A4');
    //   let pdf = new JsPDF(  
    //     Orientation, // Landscape or Portrait     
    //     unit, // mm, cm, in     
    //     format // A2, A4 etc  
    // );  

    pdf.setProperties({
      title: 'Loan Application',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });
    
    let todayDate = new Date(); 

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(15);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 220, 40);  // 40 is the height
    pdf.text("Loan Approval Statement", 235, 60);

    pdf.setLineWidth(1.5);
    pdf.line(5, 105, 590, 105)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(8);
    pdf.setFont('arial', 'normal');
    pdf.text("Approved As :" + LoanList[0].ApprovalBy.toString(), 25, 120);
    pdf.text("Centre      :" + LoanList[0].CentreName.toString(), 25, 140);
    pdf.text("Status      :" + LoanList[0].LoanApprovedStatus.toString(), 440, 120);
    pdf.text("Branch      :" + LoanList[0].CustomerBranchName.toString(), 440, 140);
    pdf.line(5, 150, 590, 150)   // x-axis, -x-axix,  y-axis  , -y-axix
    // Top HEADER END 

    // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
    // doc.table(1, 1, generateData(100), headers, { autoSize: true });

    // Body
    pdf.table(25, 165, generateData(LoanList), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');
    // Body End
  }
  ////
}
